import { useState, useRef } from "react";
// models
import {  ExperienciaProfesionalModel, initialValuesExperienciaProfesionalModel } from "../models/JuradosModel/agregarExpericienciaProfesional.model";
// api services
import JuradosService from "../api/Jurados/api-jurados";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
import { useNavigate, useParams } from "react-router";
import { juradoEditar, juradoAtras, menuJuradoAction } from '../redux/actions/juradosAction';
import { openNotification } from "../utils/saveFile";
import DocumentosService from "../api/Documentos/api-documentos";


export const useAgregarExperienciaProfesionalJurado = () => {
  const [experiencia, setExperiencia] = useState<ExperienciaProfesionalModel>(initialValuesExperienciaProfesionalModel);
  const [experiencias, setExperiencias] = useState<Array<ExperienciaProfesionalModel>>([]);
  const [modaleditar, setModaleditar] = useState<boolean>(false);
  const [modaleliminar, setModaleliminar] = useState<boolean>(false);
  const [nombreConvocatoria, setNombreConvocatoria] = useState<string>("");
  const [indexExperiencia, setIndexExperiencia] = useState<number>(0);
  const [modalVisualizar, setModalVisualizar] = useState<boolean>(false);
  // ref
  const fileInputRef = useRef<any>();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { menuJurado } = useSelector((state: RootState) => state.jurado);
  const idJurado =  localStorage.getItem('idJurado')
  const { estadoFormulario } = useParams();
  // functions

  const prevScreen = () => {
    dispatch(juradoAtras(true));
    return navigate("/usuario/educacionNoFormal")
  }

  const cargarExperienciasProfesionales = async() => {
    const experiencias = await JuradosService.obtenerReconocimientosProfesionales(idJurado)
    return setExperiencias(experiencias)
  }

  const agregarFila = () => {
    if(Array.isArray(experiencias) && experiencias.length > 0) {
      setExperiencias([...experiencias, experiencia]);
    } else {
      setExperiencias([experiencia]);
    }
    return setExperiencia(initialValuesExperienciaProfesionalModel);
  };
  const limpiarCampos = () => {
    return setExperiencia(initialValuesExperienciaProfesionalModel);
  };

  const guardarCamposModal = () => {
    let infoupdate = [...experiencias];
    infoupdate[indexExperiencia] = experiencia;
    setExperiencias(infoupdate);
    setExperiencia(initialValuesExperienciaProfesionalModel);
    return setModaleditar(false);
  };

  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (e.target.files[0].type !== "application/pdf" ) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PDF",
          placement: "bottomRight",
        });
      }
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      setExperiencia({ ...experiencia, documento: data.data });
    }
  };
  const guardarArchivoeditar = async (e: any, reconocimientossend: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (e.target.files[0].type !== "application/pdf" ) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PDF",
          placement: "bottomRight",
        });
      }
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      let infoupdate = [...reconocimientossend];
      infoupdate[indexExperiencia].documento = data.data;
      return setExperiencias(infoupdate);
    }
  };
  const eliminarFila = (indexdoc: number) => {
    let infoupdate = [...experiencias];
    infoupdate = infoupdate.filter((data:any, i: number) => i !== indexdoc)
    setExperiencias(infoupdate);
    return setModaleliminar(false);
  };


  const guardarExperienciaJurado = async() => {
    try{
      await JuradosService.guardarExperienciaProfesional(idJurado, experiencias)

      if(estadoFormulario != '' && estadoFormulario != undefined){
        dispatch(juradoEditar(false))
        return navigate('/usuario/estadosFormulario')
      }

      if (menuJurado) {
        dispatch(menuJuradoAction(false));
        return navigate('/usuario/MenuJurado');
      }

      return navigate('/usuario/agregarExperienciaJurado')

    }catch (error){
      console.log(error)
    }

  }

  const guardarExperienciaJuradoProfesional = async() => {
    try{
      await JuradosService.guardarExperienciaProfesional(idJurado, experiencias)
    }catch (error){
      console.log(error)
    }
  }

  return {
    experiencia,
    setExperiencia,
    experiencias,
    setExperiencias,
    modaleditar,
    setModaleditar,
    modaleliminar,
    setModaleliminar,
    indexExperiencia,
    setIndexExperiencia,
    fileInputRef,
    agregarFila,
    limpiarCampos,
    guardarCamposModal,
    guardarArchivo,
    guardarArchivoeditar,
    eliminarFila,
    nombreConvocatoria,
    setNombreConvocatoria,
    guardarExperienciaJurado,
    modalVisualizar,
    setModalVisualizar,
    prevScreen,
    cargarExperienciasProfesionales,
    guardarExperienciaJuradoProfesional
  };
};


